module.exports = __webpack_public_path__ + "img/modelo_small9.5d6956c4.png";